import React from 'react'
import styled from '@emotion/styled'

export default () => {
  return <Loading />
}

const Loading = () => <LoadingDiv>...</LoadingDiv>

const LoadingDiv = styled.div`
  height: 100px;
`
